import { Button } from 'antd';
import type { TruckServiceOverrideView } from '../truck-service.api';

interface ExcludedItemsProps {
  items: TruckServiceOverrideView[];
  /** Without it there is no restore button: `maintenance.view` alone reads the list. */
  onRestore?: (item: { id: string; name: string }) => Promise<void>;
}

/** What the class plan includes but this truck leaves out: the plan table doesn't list these, so this is where an exclusion is undone. */
export function ExcludedItems({ items, onRestore }: ExcludedItemsProps) {
  if (items.length === 0) return null;

  return (
    <section className="mt-6 flex flex-col gap-2" aria-label="Left out for this truck">
      <h3 className="text-sm font-medium text-fg">Left out for this truck</h3>
      <ul className="flex flex-col divide-y divide-line rounded-md border border-line bg-surface">
        {items.map((item) => (
          <li key={item.serviceItemId} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
            <span>{item.name}</span>
            {onRestore && (
              <Button size="small" onClick={() => onRestore({ id: item.serviceItemId, name: item.name })}>
                Restore
              </Button>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
